import { Component } from '@angular/core';
import { AuthService } from '../auth.service';

/**
 * Dummy component for Auth0 login callbacks
 */
@Component({
  selector: 'qm-callback',
  templateUrl: 'callback.component.html'
})
export class CallbackComponent {

  /**
   * Default constructor
   * @param {AuthService} auth
   */
  constructor(private auth: AuthService) {
    console.log('CALLBACK COMPONENT CONSTRUCTED!');
    this.auth.handleAuthenticationResult();
  }
}
